import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const PASSWORD_RESET_REQUESTS_COLLECTION = 'passwordResetRequests';

const normalizeEmail = (email) => `${email || ''}`.trim().toLowerCase();

export const requestPasswordReset = async (email) => {
  const normalizedEmail = normalizeEmail(email);

  if (!normalizedEmail) {
    throw new Error('Email is required');
  }

  await addDoc(collection(db, PASSWORD_RESET_REQUESTS_COLLECTION), {
    email: normalizedEmail,
    status: 'pending',
    requestedAt: serverTimestamp()
  });
};

